import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { ApiServicesModule } from 'src/app/extensions/services/api/api-services.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FrequentlyAskedQuestionsRoutingModule } from './faq-routing.module';
import { FrequentlyAskedQuestionsListViewComponent } from './faq-list/faq-list-view/faq-list-view.component';
import { FrequentlyAskedQuestionsListComponent } from './faq-list/faq-list.component';
import { LayoutModule } from '@progress/kendo-angular-layout';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forChild(),
    FrequentlyAskedQuestionsRoutingModule,
    ComponentsModule,
    ApiServicesModule,
    DropDownsModule,
    InputsModule,
    NgbModule,
    LayoutModule,
  ],
  declarations: [FrequentlyAskedQuestionsListComponent, FrequentlyAskedQuestionsListViewComponent],
})
export class FrequentlyAskedQuestionsModule {}
